import { render, staticRenderFns } from "./RTOShipmentsButton.vue?vue&type=template&id=60595569"
import script from "./RTOShipmentsButton.vue?vue&type=script&lang=js"
export * from "./RTOShipmentsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports